import React from 'react';
import styles from './placeholderEmptyMessage.module.scss';
import cx from 'classnames';
import DOMPurify from "dompurify";
import _ from 'lodash';


const PlaceholderEmptyMessage = (props) => {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  if (!props.visible) {
    return null;
  }

  return (
    <div className={cx(styles.container, props.className)}>
      <div className={styles.inner}>
        <img src={props.image} />
        <h1>{props.title}</h1>
        {_.get(props, "messageElement") ? (
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.messageElement) }}></p>
        ) : (
          <p>{props.message}</p>
        )}
        {props.buttonText && (
          <button className={styles.button} onClick={handleClick}>
            <span className={styles.title}>{props.buttonText}</span>
          </button>
        )}
      </div>
    </div>
  );
};

PlaceholderEmptyMessage.defaultProps = {
  title: "Opps!! Something went wrong",
  message: "We are looking into it & keep you posted",
  visible: false,
};

export default PlaceholderEmptyMessage;